module.exports = __webpack_public_path__ + "static/media/Payment-Options.39615840.png";